// 全局常量

export const SHOW_MODAL = 'SHOW_MODAL'; // 展示弹窗
export const HIDE_MODAL = 'HIDE_MODAL'; // 关闭弹窗

export const SHOW_MODAL2 = 'SHOW_MODAL2'; // 展示弹窗
export const HIDE_MODAL2 = 'HIDE_MODAL2'; // 关闭弹窗

export const SHOW_ALERT = 'SHOW_ALERT'; // 展示确认弹窗
export const HIDE_ALERT = 'HIDE_ALERT'; // 关闭确认弹窗

export const SHOW_CONFIRM = 'SHOW_CONFIRM'; // 展示确认弹窗
export const HIDE_CONFIRM = 'HIDE_CONFIRM'; // 关闭确认弹窗

export const UPDATE_USER = 'UPDATE_USER'; // 更新用户信息
export const UPDATE_USER_STATUS = 'UPDATE_USER_STATUS'; // 更新用户状态

export const UPDATE_CHANCE = 'UPDATE_CHANCE'; // 更新用户抽奖次数信息
export const UPDATE_PRIZE = 'UPDATE_PRIZE';

export const UPDATE_STYLE = 'UPDATE_STYLE'; // 更新切换状态的样式

export const SHOW_LOADING = 'SHOW_LOADING';
export const SHOW_GUIDE = 'SHOW_GUIDE';

export const GO_TO_LOGIN = 'GO_TO_LOGIN';
